import React from 'react';
import { withWebHeader } from '@24i/nxg-sdk-smartott/src/navigation/components/withWebHeader';
import { StripeCheckoutForm } from '../../../components/StripeCheckoutForm.web';
import { WithWebHeaderProps } from '../../../../../navigation/components/withWebHeader/types';
import { StripeCheckoutFormProps } from '../../../types';

type StripePurchaseViewProps = WithWebHeaderProps & StripeCheckoutFormProps;

const StripePurchaseView: React.FC<StripePurchaseViewProps> = ({ clientSecret, stripePromise }) => (
    <StripeCheckoutForm clientSecret={clientSecret} stripePromise={stripePromise} />
);

export default withWebHeader(StripePurchaseView);
